import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { setupNavigation } from "../../redux/actions/navItemsActions"
import RouteSearch from "./RouteSearch";
import { Helmet } from 'react-helmet';
import Spinner from "../common/Spinner";


function RouteKeywordSearchPage({
    user,
    setupNavigation,
    history
}) {

    const [errors, setErrors] = useState({});
    const [processing, setProcessing] = useState(false);

    const navigationItems =
    {
        sections: [{
            name: 'Search',
            items: [
                {
                    path: '/routes/explore',
                    text: 'Explore Map',
                    icon: 'fas fa-map-marked-alt'
                },
                {
                    path: '/routes/search',
                    text: 'Keyword Search',
                    icon: 'fas fa-search'
                }
            ]
        }]
    };

    useEffect(() => {
        if (!user && !user.id) {
            history.push("/login");
        }
        document.title = "Route Search | JustGoRide";
        setupNavigation(navigationItems);
    }, []);

    return (
        <React.Fragment>
            {processing ?
                <Spinner /> :
                (
                    <React.Fragment>
                        <Helmet>
                            <meta name="title" content="Search for a GPX Cycle Route | JustGoride " />
                            <meta name="description" content="Search for GPX cycle routes to go ride on your bike. This search will let you find cycle routes and bike trails that you can then download as a GPX Route file and upload to a GPS device such as Garmin or Satmap." />
                            <meta name="keywords" content="global gpx route sharing, download gpx route files, upload gpx route files, create gpx route files, search gpx route file catalog, bike rides and routes in gpx format" />
                        </Helmet>
                        <div className="keyword-search">
                            <h3>Keyword Search</h3>
                            <RouteSearch mode={"search"}/>
                        </div>
                    </React.Fragment>
                )
            }
        </React.Fragment>
    );

}

RouteKeywordSearchPage.propTypes =
    {
        user: PropTypes.object.isRequired,
        errorMessage: PropTypes.string,
        setupNavigation: PropTypes.func.isRequired
    }


function mapStateToProps(state) {
    return {
        user: state.user
    };
}

const mapDispatchToProps = {
    setupNavigation
}

export default connect(mapStateToProps, mapDispatchToProps)(RouteKeywordSearchPage); 


// WEBPACK FOOTER //
// ./src/components/routes/RouteKeywordSearchPage.js